import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OrderHttpService } from '../http/order-http.service';

@Injectable({
    providedIn: 'root',
})
export class OrdersListHttpResolverService implements Resolve<any> {
    constructor(private orderHttpService: OrderHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getOrdersByDate = this.orderHttpService.getOrdersByDate(route.params.date);
        return getOrdersByDate;
    }
}
